import { Fragment } from "react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "../../../../base";

import { StatusActions } from "./hook";

function FormConsentInstructionsTextPreview({ ...props }) {
  return <BasePreview {...props} customActions={<StatusActions />}>
    <span>
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
    </span>
  </BasePreview>
}

export default define('form-consent-instructions-text', FormConsentInstructionsTextPreview, Fragment)
  .shared(prop.share('FormConsentInstructionsText', 'form-consent-instructions-text'))
  .property(prop.predefined.customClass())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .defaultUtilities([
    '[[data-status=checked]_&]',
    '[[data-status=error]_&]',
  ])
  .defaultProps({
    space: {
      margin: "ml-1",
    },
    fontSize: "sm",
    textColor: {
      default: null,
      "[[data-status=checked]_&]": "green-950",
      "[[data-status=error]_&]": "red-950",
    },
  })
  .build()
